<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps } from 'vue';

/*==================================================================*/
/*=============== COMPONENTS IMPORTS ===============================*/
/*==================================================================*/

import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import TabelaBase from '@/components/v2/base/TabelaBase/TabelaBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({

    dado: {
        type: Object,
        default: () => ({})
    }

});

/*==================================================================*/
/*================== HEADERS DA TABELA =============================*/
/*==================================================================*/

const despesasHeaders = [
    { text: 'Número', value: 'numero', type: 'string' },
    { text: 'Despesa', value: 'despesa.descricao', width: "400px", type: 'string' },
    { text: 'Valor da Despesa', value: 'valor', type: 'money' },
    { text: 'Data da Despesa', value: 'dataDaDespesa', type: 'date' },
    { text: 'Tipo Veículo', value: 'veiculoTipo', type: 'string' },
    { text: 'Placa Veículo', value: 'veiculoPlaca', type: 'string' },
    { text: 'KM Inicial', value: 'veiculoKMInicial', type: 'km' },
    { text: 'KM Final', value: 'veiculoKMFinal', type: 'km' },
    { text: 'Anexos', value: 'anexos', width: "450px", type: 'anexo' },
    { text: 'Observação', value: 'observacao', width:"550px", type: 'string' },
];

</script>

<template>

    <CartaoBase>

        <template #header>

            <div class="c-header">

                <span class="c-header__titulo">Despesas</span>

            </div>

        </template>

        <template #body>

            <TabelaBase
                :headers="despesasHeaders"
                :dados="props.dado?.despesas"
            />
            
        </template>

    </CartaoBase>

</template>

<style scoped>

/*==================================================================*/
/*================== Card ==========================================*/
/*==================================================================*/

.c-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.c-header__titulo {
    font-size: 1.25rem;
    font-weight: 600;
}

</style>